import { useEffect, useRef } from 'react';
import { useMatch, useLocation } from 'react-router';

import { useStore } from '../storeUtils';
import { analytics } from './analytics';
import { ROUTES } from '../../routes';

const useRouteKey = () => {
  const location = useLocation();

  const pathname = location.pathname || '';
  const parts = pathname.split('/').filter(Boolean); // removes empty strings
  const routeKey = parts[1] || 'unknown'; // e.g., '/en-us/checkout' => 'checkout'

  return routeKey;
};

const useCheckoutTracking = (path: string) => {
  const [storeState] = useStore();
  const hasTracked = useRef(false);
  const routeKey = useRouteKey();

  const isRouteMatch = !!useMatch({ path: `/:lang/${path}`, end: true });
  const isHydrated = storeState.hydrated?.[routeKey];

  useEffect(() => {
    if (isRouteMatch && !hasTracked.current && isHydrated) {
      const subscription = {
        ...storeState.subscriptionInfo,
        subBundleInfo: storeState.subBundleInfo,
        planId: storeState.planId,
      };

      // Use `region` here, not `regionCode`: checkout views set context `region`
      // to request.LANGUAGE_CODE (a clean "en-us" locale) and have no `regionCode`
      // field. The cart page is the opposite — see useCartMutations.ts.
      analytics.trackCheckoutStarted(
        storeState.cart,
        subscription,
        storeState.utmData,
        storeState.region,
      );
      hasTracked.current = true;
    }
  }, [isRouteMatch, isHydrated]);
};

export const AnalyticsManager = () => {
  useCheckoutTracking(ROUTES.CHECKOUT.path);
  useCheckoutTracking(ROUTES.TOTAL_HEALTH_CHECKOUT.path);
  useCheckoutTracking(ROUTES.SUBSCRIPTION_PAYMENT.path);
  useCheckoutTracking(ROUTES.UPGRADE_SUBSCRIPTION_PAYMENT.path);
  useCheckoutTracking(ROUTES.PLATFORM_CHECKOUT.path);
  useCheckoutTracking('labs/checkout');

  return null;
};
